module.exports = __webpack_public_path__ + "static/img/ceccf60201070212aea2968d2d0fa084.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_active_04.png
// module id = Z0Yq
// module chunks = 1